import { Teacher } from '../types/teacher';
import axiosInstance from '../api/apiInterceptor';
import { AxiosResponse } from 'axios';
import { TEACHER_API_ENDPOINT, TEACHER_API_ENDPOINT_WITH_FILTER } from "../../../constants/constants"
// import { getUserToken } from "../../../lib/getUserToken";
import { getUserDetails } from "../../../lib/getUserDetails";

interface Payload {
  userId: number; 
}

const extractErrorMessage = (error: any): string => {
  if (error?.response?.data?.message) {
    return error.response.data.message;
  }

  if (error?.response?.data?.error) {
    return error.response.data.error;
  }

  if (error?.response?.data?.details) {
    return error.response.data.details;
  }

  if (error?.message) {
    return error.message;
  }

  return 'An unexpected error occurred';
};

class ApiError extends Error {
  public originalError: any;
  public statusCode?: number;

  constructor(message: string, originalError: any) {
    super(message);
    this.name = 'ApiError';
    this.originalError = originalError;
    this.statusCode = originalError?.response?.status;
  }
}

export const fetchUserDetailApi = async (payload: Payload): Promise<Teacher[]> => {
  try {
    const response: AxiosResponse<any> = await axiosInstance.get(`${TEACHER_API_ENDPOINT}/${payload.userId}`);
    return response.data.data;
  } catch (error: any) {
    console.error('Error fetching Teachers:', error);
    const message = extractErrorMessage(error);
    throw new ApiError(message, error);
  }
};

export const fetchTeachersApi = async (): Promise<Teacher[]> => {
  // const userData = getUserToken();
  // const roleIds = userData?.roleIds[0];
  const userDetail = getUserDetails();
  const schoolId = userDetail[0].relatedEntity.schools.id;
  try {
    const response: AxiosResponse<any> = await axiosInstance.get(`${TEACHER_API_ENDPOINT_WITH_FILTER}|${schoolId},roleIds|8-9&limit=200`);
    return response.data.data;
  } catch (error: any) {
    console.error('Error fetching Teachers:', error);
    const message = extractErrorMessage(error);
    throw new ApiError(message, error);
  }
};

export const fetchUserRoleApi = async () => {
  const url = `user-roles?filter=tiers%7Cschool`;
  try {
    const response: AxiosResponse<any> = await axiosInstance.get(`${url}`);
    return response.data;
  } catch (error: any) {
    console.log('Error fetch user role:', error);
    const message = extractErrorMessage(error);
    throw new ApiError(message, error);
  }
}

export const addTeacherApi = async (TeacherData: Omit<Teacher, 'id'>): Promise<Teacher> => {
  try {
    const response: AxiosResponse<Teacher> = await axiosInstance.post(TEACHER_API_ENDPOINT, TeacherData);
    return response.data;
  } catch (error: any) {
    console.error('Error adding Teacher:', error);
    const message = extractErrorMessage(error);
    throw new ApiError(message, error);
  }
};



export const updateTeacherApi = async (Teacher: Teacher): Promise<Teacher> => {
  try {
    const response: AxiosResponse<Teacher> = await axiosInstance.patch(`${TEACHER_API_ENDPOINT}/${Teacher.id}`, Teacher);
    return response.data;
  } catch (error: any) {
    console.error('Error updating Teacher:', error);
    const message = extractErrorMessage(error);
    throw new ApiError(message, error);
  }
};

export const deleteTeacherApi = async (id: number): Promise<number> => {
  try {
    await axiosInstance.delete(`${TEACHER_API_ENDPOINT}/${id}`);
    return id;
  } catch (error: any) {
    console.error('Error deleting Teacher:', error);
    const message = extractErrorMessage(error);
    throw new ApiError(message, error);
  }
};